import React from "react";
import { userRoutes, adminRoutes, publicRoutes } from "./Router";
import Layout from "./components/user/Layout";
import LayoutA from "./components/admin/Layout";
import { Routes, Route, Router } from "react-router-dom";
import Provider from "./Provider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CheckAdmin from "./CheckAdmin";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyADc4dB3qMyOQHyz1D1wnXvi2Xy8PYe4K4",
  authDomain: "internship-def00.firebaseapp.com",
  projectId: "internship-def00",
  storageBucket: "internship-def00.appspot.com",
  messagingSenderId: "1092635490548",
  appId: "1:1092635490548:web:d92537565690b41b4946a1",
  measurementId: "G-8716YDL64R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);

function App() {
  return (
    <>
      {/* <Router> */}
      <Routes>
        {publicRoutes.map((route, index) => {
          const Page = route.component;
          return <Route path={route.path} key={index} element={<Page />} />;
        })}

        <Route element={<Provider />}>
          {adminRoutes.map((route, index) => {
            const Pages = route.component;
            return (
              <Route element={<CheckAdmin />} key={index}>
                <Route element={<LayoutA />}>
                  <Route path={route.path} element={<Pages />} />
                </Route>
              </Route>
            );
          })}

          {userRoutes.map((route, index) => {
            const Pager = route.component;
            return (
              <Route element={<Layout />}>
                <Route path={route.path} key={index} element={<Pager />} />
              </Route>
            );
          })}
        </Route>
      </Routes>
      {/* </Router> */}

      <ToastContainer />
    </>
  );
}

export default App;
